export const THUMBNAIL_DELETE_RESET = 'THUMBNAIL_DELETE_RESET'
export const THUMBNAIL_DELETE_SET_ERROR = 'THUMBNAIL_DELETE_SET_ERROR'
export const THUMBNAIL_DELETE_SET_DELETED = 'THUMBNAIL_DELETE_SET_DELETED'
export const THUMBNAIL_DELETE_SET_LOADING = 'THUMBNAIL_DELETE_SET_LOADING'
